<div class="meeting-summary-header">
  <div class="flex flex-col gap-3">
    <div class="flex flex-col md:flex-row gap-3 flex-wrap justify-between items-start">
      <h2>Meeting summary for</h2>
    </div>
    <ng-container>
      <h1>{{ meeting.topic }}</h1>
      <p>{{ meeting.agenda }}</p>
      <p>{{ meeting.pastMeetingStartTime | date: 'MMM d, yyyy h:mm a' }} - {{ endTime | date: 'h:mm a' }} ({{ meeting.timezone }})</p>
    </ng-container>
    <div></div>
  </div>
</div>
